var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.625977,
    height: 6.294922,
    viewBox: "0 0 8.62598 6.29492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M0.75 3.12L3.12 5.5L7.87 0.75",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkIcon);
export default __webpack_public_path__ + "static/media/checkMarkIcon.df84d1ea11c41a0425e8b6064731c124.svg";
export { ForwardRef as ReactComponent };